import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';

import {
  actions,
  getComponentComponentLookupsAsync,
  getComponentByIdMultilingualAsync,
  createComponentByTypeIdMultilingualAsync,
  editComponentMultilingualAsync,
} from './slices';
import { Server } from '@wajeez-web/core/api-base';

export const getComponentComponentsLookups = async (
  data: { searchText?: string },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getComponentComponentLookupsAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getComponentByIdMultilingual = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getComponentByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createComponentByTypeIdMultilingual = async (
  data: Server.CreateComponentByTypeIdV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    createComponentByTypeIdMultilingualAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const editComponentMultilingual = async (
  data: Server.EditComponentV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editComponentMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const clearComponentByIdMultilingual = async () => {
  store.dispatch(actions.clearComponentByIdMultilingual());
};
